var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('BaseLoading'):_c('div',[_c('FormUserRolePermissionSetting',{attrs:{"is-submitting":_vm.create.isCreating,"permissions":_vm.permissions.data,"pdpa":_vm.pdpa.data},on:{"onConfirm":_vm.handleConfirm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }